import { Box, MenuItem, Select } from '@mui/material';

import LanguageIcon from '@mui/icons-material/Language';
import React from 'react';
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'ko', name: '한국어', flag: '🇰🇷' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
];

function LanguageSelector() {
  const { i18n } = useTranslation();

  const handleLanguageChange = event => {
    const next = event.target.value;
    i18n.changeLanguage(next);
    try {
      localStorage.setItem('locale', next);
    } catch (e) {
      // ignore localStorage write failures
    }
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        top: { xs: 10, md: 20 },
        right: { xs: 10, md: 20 },
        zIndex: 100,
      }}
    >
      <Select
        value={i18n.language}
        onChange={handleLanguageChange}
        startAdornment={<LanguageIcon sx={{ mr: 1, color: 'rgba(0, 0, 0, 0.54)' }} />}
        sx={{
          bgcolor: 'white',
          borderRadius: '25px',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#e0e0e0',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#667eea',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#667eea',
          },
          minWidth: 150,
          fontSize: { xs: '0.875rem', md: '1rem' },
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        {LANGUAGES.map(lang => (
          <MenuItem key={lang.code} value={lang.code}>
            {lang.flag} {lang.name}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}

export default LanguageSelector;
